<template>
  <div
    :class="[
      'button',
      {
        blackLayout: labelColor === 'black',
        whiteLayout: labelColor === 'white',
      },
    ]"
  >
    {{ labelText }}
  </div>
</template>

<script>
export default {
  name: "TextLabel",
  props: {
    labelColor: {
      type: String,
      default: "white",
    },
    labelText: {
      type: String,
      default: "Default Text",
    },
  },
};
</script>

<style scoped>
.button {
  width: fit-content;
  height: 29px;
  border: 1px solid #ffffff;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 14px;
  transition: all 0.3s ease;
}

.whiteLayout {
  color: #ffffff;
  border-color: #ffffff;
}

.blackLayout {
  color: #000000;
  border-color: #000000;
  opacity: 0.6;
}

@media (max-width: 1024px) {
  .button {
    height: 22px;
    font-size: 12px;
    padding: 0px 12px;
  }
}
</style>
